import type { CityConfig } from "@/pages/city-template/types";

export const romeNyConfig: CityConfig = {
  city: "Rome",
  state: "New York",
  stateAbbr: "NY",
  slug: "rome-ny",
  route: "/cities/rome-ny",
  title: "Emergency & Expedited Passport Rome NY | Same Day Passport Rome",
  metaDescription:
    "Emergency passport Rome NY — same day, 24-hour, and 3-5 day expedited passport processing for Oneida County. Fast Passport Center serves Rome, Utica, New Hartford, and all Mohawk Valley communities.",
  h1: "Emergency & Expedited Passport Services in Rome, NY",
  heroSubtitle:
    "Rome's fast passport solution — from the historic City of Rome to the Mohawk Valley. Whether you're flying out of Syracuse Hancock or Albany International, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Rome%20New%20York%20downtown%20with%20historic%20buildings%20and%20Fort%20Stanwix%20National%20Monument%2C%20Erie%20Canal%20heritage%20corridor%2C%20Mohawk%20Valley%20landscape%20with%20rolling%20hills%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20historic%20cityscape%20with%20scenic%20valley%20backdrop&width=1600&height=700&seq=ny-rome-hero-001&orientation=landscape",
  heroImageAlt: "Rome New York downtown with historic buildings and Fort Stanwix National Monument",
  geoPosition: "43.2128; -75.4557",
  geoPlacename: "Rome, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~240 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "New Hartford", zips: "13413, 13414, 13420" },
    { name: "Whitesboro", zips: "13492" },
    { name: "Yorkville", zips: "13495" },
    { name: "Marcy", zips: "13403" },
    { name: "Oriskany", zips: "13424" },
    { name: "Oneida", zips: "13421" },
    { name: "Vernon", zips: "13476, 13478" },
    { name: "Verona", zips: "13478" },
    { name: "Sherrill", zips: "13461" },
    { name: "Camden", zips: "13316" },
    { name: "Boonville", zips: "13309" },
    { name: "Barneveld", zips: "13304" },
    { name: "Remsen", zips: "13438" },
    { name: "Ilion", zips: "13357" },
    { name: "Herkimer", zips: "13350" },
    { name: "Little Falls", zips: "13365" },
    { name: "Clinton", zips: "13323" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Gloversville", zips: "12078" },
    { name: "Amsterdam", zips: "12010" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Rome travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Rome residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Oneida County & Mohawk Valley",
      desc: "Rome, Utica, New Hartford, and the entire Mohawk Valley — we serve all of Oneida, Herkimer, and Lewis counties.",
    },
  ],
  testimonials: [
    {
      name: "Robert K.",
      location: "Rome, NY",
      rating: 5,
      text: "Had a family emergency overseas and needed my passport renewed in 3 days. Fast Passport Center delivered in 2. Amazing service for Rome area residents.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia M.",
      location: "New Hartford, NY",
      rating: 5,
      text: "First-time passport for my daughter's school trip. The agent walked us through the acceptance clerk process at the Rome Post Office. Processed in 5 days.",
      service: "New Passport",
    },
    {
      name: "James T.",
      location: "Whitesboro, NY",
      rating: 5,
      text: "Lost my passport before a business trip. Fast Passport Center handled the replacement process and had it back to me in 4 days. Highly recommend for Rome area.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "rome-1",
      name: "Rome Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "262 W Dominick Street",
      city: "Rome",
      state: "NY",
      zip: "13440",
      phone: "315-336-1070",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Rome",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Rome passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "rome-2",
      name: "New Hartford Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "49 Genesee Street",
      city: "New Hartford",
      state: "NY",
      zip: "13413",
      phone: "315-733-7161",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "New Hartford (~8 miles southeast)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for New Hartford and southeast Rome residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "rome-3",
      name: "Utica Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1000 Park Avenue",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "315-735-6620",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Utica (~15 miles east)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Utica, east Oneida County, and Mohawk Valley communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Rome, NY?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Rome residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Rome?",
      a: "The Rome Post Office at 262 W Dominick Street is the major Rome passport acceptance facility. The New Hartford Post Office at 49 Genesee Street and Utica Main Post Office at 1000 Park Avenue are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Rome, NY?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Rome, New Hartford, and Utica. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Rome?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Rome passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Rome, New York?",
      a: "The fastest way to renew a passport in Rome is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Rome, NY?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Rome and all Oneida County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Rome?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Rome. We serve the City of Rome and all of the Mohawk Valley through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Rome", address: "various CVS locations across Rome, New Hartford, and Utica", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Rome", address: "various Walgreens locations throughout Rome and Oneida County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Rome", address: "various UPS Store locations in Rome and New Hartford", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Rome", address: "various FedEx Office locations across Rome", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Rome", address: "various Walmart locations in Rome and New Hartford", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Rome",
      address: "1836 Black River Boulevard, Rome, NY 13440",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Rome DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — New Hartford",
      address: "8640 Clark Mills Road, New Hartford, NY 13413",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "New Hartford DMV office serving suburban Rome, New Hartford, and Clinton residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Utica",
      address: "321 Main Street, Utica, NY 13501",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Utica DMV office serving east Oneida County and Mohawk Valley communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~50 miles from Rome",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Closest major airport to Rome with flights to major U.S. hubs. Primary airport for Mohawk Valley travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~95 miles from Rome",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with flights to major U.S. cities and some international destinations. Alternative for Rome travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "~200 miles from Rome",
      address: "4200 Genesee Street, Buffalo, NY 14225",
      note: "Major international airport in Buffalo with direct flights to Europe and worldwide destinations. Alternative for Rome area travelers.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Rome travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Rome residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Rome residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Rome residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Rome, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Rome residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Rome travelers with immediate departure needs from Syracuse Hancock or Albany International." },
    { name: "Passport Renewal", description: "Fast passport renewal for Rome residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Rome residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Rome residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Rome and Oneida County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Rome." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Rome travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Rome travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Rome team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Rome address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Rome and all of the Mohawk Valley as a remote courier service. We do not have a physical office in Rome, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Rome area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Rome and all of Oneida County. From the City of Rome to the Mohawk Valley, from Utica to New Hartford — we serve central New York with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Rome and all surrounding communities across Oneida County and the Mohawk Valley. Whether you're in New Hartford, Whitesboro, or Oneida, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Rome customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Rome travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Rome travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Rome. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default romeNyConfig;